import React, { useEffect, useState } from "react";
import { apiClient } from "../api_client"
import { RACE_STATES, DEFAULT_RACE_STATUS } from "../constants/race";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";


export default function StillRacing({id}) {
  const navigate = useNavigate();
  const [eventId, setEventId] = useState(null);
  const [entrants, setEntrants] = useState([]);
  const [raceNumber, setRaceNumber] = useState("");
  const [finTime, setFinTime] = useState("");
  const [raceStatus, setRaceStatus] = useState(String(RACE_STATES.FINISHED));
  const [loading, setLoading] = useState(true);
  const [submittingEntrants, setSubmittingEntrants] = useState([]);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 10000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submittingItem = { raceNumber, state: raceStatus };
    setSubmittingEntrants(prev => [...prev, submittingItem]);

    try {
      await apiClient.stillRacing.uploadFinish(id, raceNumber, raceStatus, finTime);
      setRaceNumber("");
      setFinTime("");
      refresh();
    } catch (err) {
      console.error(err);
      alert(err || "Submission failed");
    } finally {
      setSubmittingEntrants(prev => prev.filter(item => item.raceNumber !== raceNumber));
    }
  };


  const handleReset = (raceNumber) => {
    apiClient.stillRacing.resetRacer(id, raceNumber)
    .then((res) => {
      refresh();
      return res;
    })
    .catch((err) => {
      showToast(err, "error");
    });
  }

  const refresh = async () => {
    if (entrants.length == 0) {
      setLoading(true);
    }
    try {
      const result = await apiClient.stillRacing.getRacers(id);
      setEntrants(
        result.entrants.map(ent => ({
          id: ent.id,
          raceNumber: ent.race_number,
          forename: ent.forename,
          surname: ent.surname,
          state: ent.racing_state,
          finTime: ent.fin_time,
          startFlag: ent.start_flag,
          endFlag: ent.end_flag
        }))
      );
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  const goToEntrant = (entrant) => {
    navigate(
      `/entrants/${entrant.id}`,
      {
        state: {
          entrantName: `${entrant.forename} ${entrant.surname}`,
          raceNumber: entrant.raceNumber,
        }
      }
    );
  };

  return (
    <div style={{ display: "flex", gap: "2rem" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        {/* Form Section */}
        <h1>Manual Entry</h1>
        <div className="form-con row p-2 card">
          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <label htmlFor="race_number">Race Number:</label>
              <input
                id="race_number"
                type="text"
                value={raceNumber}
                className="form-control"
                onChange={(e) => setRaceNumber(e.target.value)}
                required
              />
            </div>

            <div className="mb-2">
              <label>Race Status:</label>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <label style={{ flex: "0 0 100px", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  DNS:
                  <input
                    type="radio"
                    value={String(RACE_STATES.DNS)}
                    checked={raceStatus === String(RACE_STATES.DNS)}
                    onChange={(e) => setRaceStatus(e.target.value)}
                  />
                </label>

                <label style={{ flex: "0 0 100px", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  DNF:
                  <input
                    type="radio"
                    value={String(RACE_STATES.DNF)}
                    checked={raceStatus === String(RACE_STATES.DNF)}
                    onChange={(e) => setRaceStatus(e.target.value)}
                  />
                </label>
                
                <label style={{ flex: "0 0 100px", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  Finished:
                  <input
                    type="radio"
                    value={ String(RACE_STATES.FINISHED) }
                    checked={raceStatus === String(RACE_STATES.FINISHED)}
                    onChange={(e) => setRaceStatus(e.target.value)}
                  />
                </label>
              </div>
            </div>

            <div className="mb-2">
              <label htmlFor="fin_time">Finish Time:</label>
              <input
                id="fin_time"
                type="text"
                placeholder="HH:MM:SS"
                value={finTime}
                className="form-control"
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow input if it matches or is partially valid
                  if (value === '' || /^(\d{0,2}:?\d{0,2}:?\d{0,2})$/.test(value)) {
                    setFinTime(value);
                  }
                }}
                disabled={raceStatus !== String(RACE_STATES.FINISHED)}
                required={raceStatus === String(RACE_STATES.FINISHED)}
                pattern="^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$"
                title="Enter time in HH:MM:SS format (24-hour clock)"
              />
              {finTime &&
                !/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(finTime) && (
                  <p style={{ color: 'red' }}>Invalid time format. Use HH:MM:SS.</p>
                )}
            </div>

            <button type="submit" className="btn btn-success">Submit Finish Time</button>
          </form>
        </div>

        <div className="row">
        
          {/* DNS Table */}
          <div style={{ flex: "0 0 150px" }} className="table-con">
            <h1>DNS</h1>
              <table className="table-sm table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Race Number</th>
                    <th style={{ minWidth: "40px", textAlign: "center" }}>
                    <i className="fa-regular fa-trash-can"></i>
                  </th>                
                </tr>
              </thead>
              <tbody>
                {(entrants.length === 0 && loading) ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                )  : (
                  <>
                    {submittingEntrants
                      .filter(item => item.state == RACE_STATES.DNS)
                      .map((item, index) => (
                        <tr key={`submitting-dns-${index}`} style={{ opacity: 0.5 }}>
                          <td>{item.raceNumber}</td>
                          <td>
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                              <span className="visually-hidden">Submitting...</span>
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                    {entrants
                      .filter((entrant) => entrant.state == RACE_STATES.DNS)
                      .map((entrant) => (
                        <tr key={entrant.id}>
                          <td>{entrant.raceNumber}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (window.confirm(`Are you sure you want to set bib: ${entrant.raceNumber} to racing?`)) {
                                  handleReset(entrant.raceNumber);
                                }
                              }}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    }
                  </>
                )}
              </tbody>
            </table>
          </div>

          {/* DNF Table */}
          <div style={{ flex: "0 0 150px" }} className="table-con">
            <h1>DNF</h1>
            <table className="table-sm table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Race Number</th>
                  <th style={{ minWidth: "40px", textAlign: "center" }}>
                    <i className="fa-regular fa-trash-can"></i>
                  </th>
                </tr>
              </thead>
              <tbody>

                {(entrants.length === 0 && loading) ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {submittingEntrants
                      .filter(item => item.state == RACE_STATES.DNF)
                      .map((item, index) => (
                        <tr key={`submitting-dnf-${index}`} style={{ opacity: 0.5 }}>
                          <td>{item.raceNumber}</td>
                          <td>
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                              <span className="visually-hidden">Submitting...</span>
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                    {entrants
                      .filter((entrant) => entrant.state == RACE_STATES.DNF)
                      .map((entrant) => (
                        <tr key={entrant.id}>
                          <td>{entrant.raceNumber}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (window.confirm(`Are you sure you want to set bib: ${entrant.raceNumber} to racing?`)) {
                                  handleReset(entrant.raceNumber);
                                }
                              }}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    }
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Finished Table */}
      <div style={{flex: "2"}} className="table-con">
        <h1>Finished</h1>
          <div className="table-responsive">
            <table className="table-sm table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Position</th>
                  <th>Race Number</th>
                  <th colSpan={2}>Name</th>
                  <th>Finish Time</th>
                  <th style={{ minWidth: "40px", textAlign: "center" }}>
                    <i className="fa-regular fa-trash-can"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                {(entrants.length === 0 && loading) ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {submittingEntrants
                      .filter(item => item.state == RACE_STATES.FINISHED)
                      .map((item, index) => (
                        <tr key={`submitting-dnf-${index}`} style={{ opacity: 0.5 }}>
                          <td>?</td>
                          <td>{item.raceNumber}</td>
                          <td colSpan={4} className="text-center">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                              <span className="visually-hidden">Submitting...</span>
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                    {
                    [...entrants]
                      .filter((entrant) => entrant.state == RACE_STATES.FINISHED)
                      .sort((a, b) => {
                        if (!a.finTime) return 1;
                        if (!b.finTime) return -1;
                      return a.finTime.localeCompare(b.finTime);
                    })
                    .map((entrant, index) => (
                      <tr
                        key={entrant.id}
                        onClick={() => goToEntrant(entrant)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{index + 1}</td>
                        <td>{entrant.raceNumber}</td>
                        <td>{entrant.forename}</td>
                        <td>{entrant.surname}</td>
                        <td>{entrant.finTime || "N/A"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (window.confirm(`Are you sure you want to set bib: ${entrant.raceNumber} to racing?`)) {
                                handleReset(entrant.raceNumber);
                              }
                            }}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                  </>
                )}
              </tbody>
            </table>
          </div>
      </div>

      {/* Racing Table */}
      <div style={{flex: "2"}} className="table-con">
        <h1>Racing</h1>
        <table className="table-sm table table-striped table-bordered">
          <thead>
            <tr>
              <th>Race Number</th>
              <th colSpan={2}>Name</th>
              <th>Flag</th>
            </tr>
          </thead>
            <tbody>
              {(entrants.length === 0 && loading) ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
              (entrants || [])
                .filter((entrant) => entrant.state === RACE_STATES.RACING)
                .sort((a, b) => {
                  const aRace = String(a.raceNumber || "");
                  const bRace = String(b.raceNumber || "");
                  return aRace.localeCompare(bRace, undefined, { numeric: true });
                })
                .map((entrant) => {
                  let flagColor = "";
                  let tooltip = "";

                  if (entrant.startFlag === 1) {
                    flagColor = "yellow";
                    tooltip = "No safety beacons detected";
                  } else if (entrant.startFlag === 2) {
                    flagColor = "red";
                    tooltip = "No start time detected";
                  } else {
                    flagColor = "green";
                    tooltip = "Racing";
                  }
                  if (entrant.endFlag === 2) {
                    flagColor = "red";
                    tooltip = "Finish time not detected";
                  }

                  return (
                    <tr
                      key={entrant.id}
                      onClick={() => goToEntrant(entrant)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{entrant.raceNumber}</td>
                      <td>{entrant.forename}</td>
                      <td>{entrant.surname}</td>
                      <td>
                        {flagColor === "green" && (
                          <FaCheckCircle title={tooltip} color="green" size={18} />
                        )}

                        {flagColor === "yellow" && (
                          <FaInfoCircle title={tooltip} color="orange" size={18} />
                        )}

                        {flagColor === "red" && (
                          <FaExclamationTriangle title={tooltip} color="red" size={18} />
                        )}
                      </td>

                    </tr>
                  );
                }))}
            </tbody>
          </table>
      </div>
    </div>
  );
}